import i18next from "i18next";
import { toast as toastify, TypeOptions } from "react-toastify";

export const showToast = (message: string, type: TypeOptions) => {
  toastify(i18next.t(message), {
    type,
  });
};
